import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { IoMdHeartEmpty } from "react-icons/io";
import ReactImageMagnify from "react-image-magnify";
import { FaRegStar, FaShoppingBag, FaShoppingCart, FaStar, FaStarHalfAlt } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import DOMPurify from "dompurify";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AddReview from "../components/AddReview";
import ProductCard from "../components/ProductCard";
import { FaRegShareFromSquare } from "react-icons/fa6";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { BsLightningCharge } from "react-icons/bs";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MyContext } from "../../context/MyContext";



const ProductDetail = () => {
  const { MLMStatus, verifyMlmUser } = useContext(MyContext);
  const navigate = useNavigate();
  var { id } = useParams();
  id = parseInt(id);
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [activeTab, setActiveTab] = useState("description");
  const [loading, setLoading] = useState(true);
  const [first, setFirst] = useState([]);
  // const [selectedPrice,setselectedPrice]=useState({});
  const [selectedColor, setSelectedColor] = useState(""); // Track the selected color
  const [cartImage, setCartImage] = useState([]);
  const [description, setDescription] = useState("");
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
  const [isZooming, setIsZooming] = useState(false);
  // console.log("cartImage is", typeof cartImage);
  const [productName, setProductName] = useState("");
  const [mainproduct, setProduct] = useState({});
  const [mainPrice, setMainPrice] = useState([]);
  const [saleprice, setSalePrices] = useState("");
  const [oldPrice, setOldPrices] = useState("");
  const [images, setImages] = useState([]);
  const [configurations, setConfigurations] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [sizeIndex, setSizeIndex] = useState(0);
  const [colorIndex, setColorIndex] = useState(0);
  const [coin, setCoin] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [configColor, setConfigColor] = useState(null);
  const [categories, setCategories] = useState('');
  const [config2,setCongfig2]=useState(undefined);
  const totalQuantity = useSelector((state) => state.cart.totalQuantity);
  const sanitizedDescription = DOMPurify.sanitize(description);
  const Description = DOMPurify.sanitize(description?.slice(0, 800));
  console.log("main description        is ---> ", description);
  useEffect(() => {
    console.log("now is product details");

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    async function getProduct() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_NODE}user/singleProduct/${id}`
        );

        const product = response?.data?.data?.[0];
        setImages(product.prices[0].images || []);
        setProduct(product);
        setProductName(product.name);
        setCoin(product.coin);
        setDescription(product.description);
        console.log("setproduct is ", product.name);
        setMainPrice(product.prices);
        setSalePrices(product.prices[0].config[0].sale_price);
        setOldPrices(product.prices[0].config[0].old_price);
        setConfigColor(product.prices[0].config1);
        setMainImage(product.featured_image || "");
        setCongfig2(product?.prices[0]?.config[0]?.config2)
        setCategories(product?.categoryDetail[0]?.categorie_name);
        setConfigurations(product?.prices[0].config);

        const defaultColor = product.prices[0].color_name;
        setSelectedColor(defaultColor);
        console.log("Default color selected:", defaultColor);
      } catch (error) {
        console.error("Error fetching product details:", error);
      } finally {
        setLoading(false);
      }
    }
    getProduct();
    fetchFirstCampaign();

    const handleBackButton = () => {
      console.log("Browser back button clicked!");
      // Perform any action when user clicks back
      // Example: Navigate to another page or show a confirmation alert
      navigate(-1); // Redirect to home page
    };

    window.addEventListener("popstate", handleBackButton);
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
      window.removeEventListener("resize", checkMobile);
    };
  }, ["", id]);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    console.log(e.clientX, " ", e.clientY);
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoomPosition({ x, y });
  };
  const fetchFirstCampaign = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODE}admin/campaign/page/product/location/1`
      );
      const data = response.data.data;

      if (Array.isArray(data) && data.length > 0) {
        const lastElement = data[data.length - 1]; // Access the last element
        console.log("Last Element:", lastElement);
        setFirst(lastElement); // Set the last element as state
      } else {
        console.log("Data is not an array or is empty");
      }
      console.log("response 1", response.data.data);
    } catch (error) {
      console.error("error in get first campaign", error);
    }
  };

  if (!mainproduct) return <div>Product not found</div>;

  const handleAddToCart = async (productId, venderId) => {
    if (!token) {
      navigate(`/login-user`);
      return;
    }
    try {
      const configuratioId = configurations[sizeIndex].id;
      // console.log("Configuration ID is ", configuratioId);
      const response = await axios.post(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}cart/add-product/${userId}/${productId}`,
        {
          quantity: 1,
          configuration_id: configuratioId,
          color: selectedColor,
        }
      );
      console.log("product added to cart: ", response);
      if (response.status == 200) {

        toast.success("Added in Cart Successfully!");
        navigate("/cart");
      }
    } catch (err) {
      console.log("product not found: ", productId);
    }
  };

  const handleBuyNow = async (productId, venderId) => {
    if (!token) {
      navigate(`/login-user`);
      return;
    }

    const dataa = {
      user_id: userId,
      color: selectedColor,
      products: productId,
      size: configurations[sizeIndex].size,
      product_configuration_id: configurations[sizeIndex].id,
      old_price: oldPrice,
      price: saleprice,
      quantity: 1,
      image_url: mainImage,
      product_name: productName,
      coin: coin,
      vendor_id: venderId,
    };

    console.log("buying data is is", dataa);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODE}/user/order/buyOrders`,
        dataa
      );

      const buyId = response.data.data.insertId;
      // alert("Product buying!");
      toast.success("Product Buying!");
      navigate(`/buySummary/${buyId}`, { state: { buyId } });
    } catch (error) {
      console.error("Error in Buying Product", error);
    }
  };

  const handleWishlist = async (productId, venderId) => {
    const data = {
      color: selectedColor,
      size: "L",
      configurations: configurations,
      old_price: oldPrice,
      sale_price: saleprice,
    };
    console.log("the data Wishlist  is ", data);
    try {
      await axios.post(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}wishlist/user_id_${userId}/vendor_id_${venderId}/product_id_${productId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // alert("Product added to wishlist!");
      toast.success("Product added to wishlist!");
    } catch (error) {
      console.error("Error in addWishlist", error);
      // alert("Select the color of item to add in Wishlist!");
      toast.error("Select the color of item to add in Wishlist!");
    }
  };

  const renderStars = (rating, maxRating = 5) => {
    const stars = Array.from({ length: maxRating }, (_, index) => {
      const currentRating = index + 1;
      if (rating >= currentRating) {
        return <FaStar key={index} className="text-yellow-400" />;
      } else if (rating >= currentRating - 0.5) {
        return <FaStarHalfAlt key={index} className="text-yellow-400" />;
      } else {
        return <FaRegStar key={index} className="text-yellow-400" />;
      }
    });
    return <div className="flex">{stars}</div>;
  };

  function setDetailsProduct(index) {
    setSalePrices(configurations[index].sale_price);
  }

  function setProductDetails(value) {
    const newObje = mainPrice?.find((price) => price?.color_name === value);
    console.log(newObje?.images[0], value);
    setSizeIndex(0);
    setImages(newObje?.images);
    setMainImage(newObje?.images[0]?.image_path);
    setSalePrices(newObje?.config[0]?.sale_price);
    setConfigurations(newObje?.configurations);
    setSelectedColor(value);

    // setCartImage(selectedPrice.images[0].image_path);
  }
  // Find the selected price based on the selected color

  // Set default image


  const handleShareLink = () => {
    const currentUrl = window.location.href;
    const message = `Check out this product: ${currentUrl}`;

    if (navigator.share) {
      navigator
        .share({
          title: "Product Share",
          text: message,
          url: currentUrl,
        })
        .then(() => console.log("Shared successfully"))
        .catch((err) => console.error("Share failed:", err));
    } else {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      const mailtoUrl = `mailto:?subject=Check out this product&body=${encodeURIComponent(message)}`;

      window.open(whatsappUrl, "_blank");
      window.open(mailtoUrl, "_blank");
    }
  };

  return (
    <div className={`pt-4 md:pt-2 ${verifyMlmUser ? "lg:pt-[100px]" : "lg:pt-40"}`}>
      <div className="flex flex-col relative ml-6 mr-6 ">
        {loading ? (
          // Render Skeleton Loader
          <div className="flex flex-col md:flex-row rounded-lg overflow-hidden relative">
            {/* Left Section */}
            <div className="w-full sticky top-10 h-[700px] md:w-1/2 sm:p-8">
              <Skeleton width={630} height={500} className="rounded-lg" />
              <div className="flex overflow-x-auto mt-2 space-x-2">
                {[...Array(5)].map((_, index) => (
                  <Skeleton
                    key={index}
                    width={120}
                    height={130}
                    className="rounded-lg"
                  />
                ))}
              </div>
            </div>

            {/* Right Section */}
            <div className="w-full md:w-1/2 lg:p-4 flex flex-col sm:pt-6 ">
              <Skeleton width="50%" height={24} className="mb-4" />
              <Skeleton width="50%" height={24} className="mb-4" />
              <Skeleton width={80} height={20} className="mt-4" />
              <Skeleton width="33%" height={24} className="mb-2" />
              <Skeleton width="100%" height={48} className="mb-4" />
              <Skeleton width="25%" height={16} className="mr-2" />
              <Skeleton width="33%" height={16} />
              <div className="flex flex-col border-b-2 space-y-6 pb-4">
                <Skeleton width={64} height={16} />
                {[...Array(3)].map((_, index) => (
                  <Skeleton
                    key={index}
                    width={48}
                    height={24}
                    className="rounded-md"
                  />
                ))}
              </div>
              <Skeleton width={112} height={32} className="rounded-full mt-6" />
              <Skeleton width={112} height={32} className="rounded-full" />
            </div>
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row  rounded-lg overflow-hidden relative">
            {/* ------------------------------------- */}
            <div className="w-full md:w-[60%] sticky top-10 sm:p-8 flex flex-col md:flex-row">
              {/* Main Image (comes first on desktop, second on mobile) */}
              <div className="flex-1 order-1 md:order-2 mb-4 md:mb-0">
                {isMobile ? (
                  <img
                    src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/product/${mainImage}`}
                    alt={mainproduct.name}
                    className="w-full h-[300px] object-contain rounded-lg"
                  />
                ) : (
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: `${mainImage}`,
                        src: `${process.env.REACT_APP_NODE_CATEGORY}uploads/product/${mainImage}`,
                        width: 630,
                        height: 500,
                        style: { borderRadius: "20px" },
                      },
                      largeImage: {
                        src: `${process.env.REACT_APP_NODE_CATEGORY}uploads/product/${mainImage}`,
                        width: 1030,
                        height: 900,
                      },
                    }}
                  />
                )}
              </div>

              {/* Thumbnails (below on mobile, left on desktop) */}
              <div className="flex gap-2 overflow-x-auto md:overflow-y-auto md:flex-col md:max-h-[500px] order-2 md:order-1">
                {images.map((image, imageIndex) => (
                  <img
                    key={imageIndex}
                    src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/product/${image.image_path}`}
                    alt={mainproduct.name}
                    onClick={() => setMainImage(image.image_path)}
                    className="h-[100px] min-w-[100px] object-contain rounded-lg border-2 border-gray hover:border-purple-500 cursor-pointer"
                  />
                ))}
              </div>
            </div>


            {/* -------------------------------------------- */}

            <div className="custom-scrollbar w-full md:w-1/2  lg:p-4 pt-6 flex flex-col sm:pt-6 lg:overflow-y-auto lg:max-h-[calc(100vh-100px)] max-h-screen-minus-100">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl md:text-2xl font-bold mt-5">
                    {mainproduct.name}
                  </h2>
                </div>

              </div>

              <div className="flex space-x-2 md:space-x-4 items-center h-[40px] md:h-[50px]">
                <p className="border-r-2 border-gray-300 pr-2 md:pr-4">
                  {renderStars(mainproduct.rating)}
                </p>
                <a
                  href="#productReview"
                  className="text-blue-500 text-sm md:text-base cursor-pointer"
                >
                  Add Review
                </a>
              </div>
              <div className="flex gap-4">
                <div className="my-[20px] rounded-[15px] bg-[#FACC15] p-[5px_20px] w-fit">
                  <span className="text-[#000]">{categories}</span>
                </div>
                <div className="my-[20px] rounded-[15px] bg-[#FACC15] p-[5px_20px] w-fit cursor-pointer flex ">
                  <button onClick={handleShareLink}><FaRegShareFromSquare className="w-[20px] h-[20px]" /></button>
                </div>
              </div>
              <div className="flex jutsify-center items-center">
                <p className=" md:text-[22px] font-semibold mb-2 md:mb-2">
                  MRP: ₹{saleprice}
                </p>
                <p className="ml-[5px]  text-[18px] text-gray-500 ">
                  <del className="font-bold">{oldPrice}</del>
                </p>
              </div>
              <p className="font-semibold mt-[10px] text-lg text-orange-500">
                Coins: {mainproduct.coin}
              </p>
              <div className="flex flex-col border-b-2 mt-[20px]  space-y-6">
                <div className="flex items-center gap-4 ">
                  <p className="font-semibold text-lg ">
                    {configColor || "Color"}:
                  </p>
                  {mainPrice.map((price, index) => (
                    <div key={index} className="flex items-center">
                      <button
                        onClick={() => {
                          setColorIndex(index);
                          setProductDetails(price?.color_name);
                          setConfigurations(mainPrice[index]?.config)
                        }} // Set selected color
                        className={`${colorIndex === index
                          ? "bg-purple-600 text-white"
                          : "border-gray-400"
                          } border px-2 py-1 rounded-md cursor-pointer ml-2`}
                      >
                        {price?.color_name}
                      </button>
                    </div>
                  ))}

                  {selectedColor === null && (
                    <p className="mt-4 text-red-600 text-sm text-semibold">
                      Please select a color and Size before Buying.
                    </p>
                  )}
                </div>

                <div className="flex  space-y-5 ">
                  <div className="flex items-center gap-4  mb-2 sm:mb-0">
                    {configurations?.map((config, configIndex) => (
                      <div key={configIndex} className="flex  items-center ">
                        <p className="font-semibold  text-lg">
                          {config2||"size"} :
                        </p>

                        <button
                          type="text"
                          value={config?.size}
                          readOnly
                          className={`${sizeIndex === configIndex
                            ? "border-purple-600"
                            : "border-gray-400"
                            } border px-2 py-1 rounded-md cursor-pointer ml-2`}
                          onClick={() => {
                            setSizeIndex(configIndex);
                            setDetailsProduct(configIndex);
                          }}
                        >
                          {config.size}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="hidden md:flex items-center h-[40px] md:h-[50px] mt-6 space-x-2 md:space-x-4 flex-wrap">

                  <button
                    onClick={() => handleBuyNow(mainproduct.id, mainproduct.vendor_id)}
                    className="flex items-center justify-center gap-2 flex-1 bg-purple-500 text-white px-4 py-1 rounded-md hover:bg-purple-700 transition-colors sm:px-5 sm:py-2"
                  >
                    <MdKeyboardDoubleArrowRight className="text-lg" />
                    Buy Now
                  </button>
                  <button
                    disabled={loading}
                    onClick={() => handleAddToCart(mainproduct.id, mainproduct.vendor_id)}
                    className="flex items-center justify-center gap-2 flex-1 bg-transparent border-[2px] border-purple-500 text-purple-500 px-4 py-1 rounded-md hover:bg-purple-500 hover:text-white transition-colors sm:px-5 sm:py-2"
                  >
                    <AiOutlineShoppingCart className="text-lg" />
                    {loading ? "Adding..." : "Add To Cart"}
                  </button>
                </div>
              </div>
              <div
                className="p-[10px_0]"
                style={{ whiteSpace: "pre-wrap" }}
                dangerouslySetInnerHTML={{ __html: Description }}
              ></div>
            </div>
          </div>
        )}

        <div className="lg:m-4">
          <div className="flex space-x-4 mb-5 border-b-2 lg:mt-4">
            <button
              className={`py-2 px-4 ${activeTab === "description"
                ? "border-black border-b-2 font-semibold"
                : ""
                }`}
              onClick={() => setActiveTab("description")}
            >
              Description
            </button>

            <button
              className={`py-2 px-4 ${activeTab === "details"
                ? "border-black border-b-2 font-semibold"
                : ""
                }`}
              onClick={() => setActiveTab("details")}
            >
              Details
            </button>
          </div>

          <div>
            {activeTab === "description" && (
              <div className="m-4">
                <h3 className="font-bold">Product Description</h3>
                <div
                  className="text-black mb-4"
                  style={{ whiteSpace: "pre-wrap" }}
                  dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                ></div>
              </div>
            )}
            {activeTab === "details" && (
              <div className="m-4">
                <h3 className="font-bold">Product Details</h3>
                <p>Dimensions: {mainproduct.dimensions}</p>
                <p>Weight: {mainproduct.weight}</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="w-full md:max-w-[96vw] h-[130px] md:h-[530px] bg-white-200 lg:mx-5 shadow-lg overflow-hidden ">
        <img
          src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/campaign/${first.image}`}
          alt=""
          className="w-full h-full object-contain md:object-cover p-4 "
        />
      </div>

      <div className="mb-3">
        <AddReview />
      </div>
      <ProductCard />

      {/* for mobile view */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-md p-2 md:hidden flex justify-between items-center">

        <button
          className="flex items-center justify-center gap-2 bg-purple-500 text-white px-6 py-3 rounded-md hover:bg-purple-700 transition-colors sm:px-10 sm:py-2"
          onClick={() => handleBuyNow(mainproduct.id, mainproduct.vendor_id)}
        >
          <MdKeyboardDoubleArrowRight className="text-lg"
          />
          Buy Now
        </button>

        <button
          disabled={loading}
          onClick={() => handleAddToCart(mainproduct.id, mainproduct.vendor_id)}
          className="flex items-center justify-center gap-2 bg-transparent text-purple-500 border-[2px] border-purple-500 px-6 py-3 rounded-md hover:bg-purple-700 transition-colors sm:px-10 sm:py-2"
        >
          <FaShoppingCart className="text-lg" />
          {loading ? "Adding..." : "Add To Cart"}
        </button>

      </div>
    </div>
  );
};

export default ProductDetail;
